(function () {
  'use strict';

  angular.module('app').component('featureCategoryDetail', featureCategoryDetail());

  function featureCategoryDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        additionalLanguages: '<',
      },
      controller: FeatureCategoryDetailCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/admin/feature-categories/feature-category-detail/feature-category-detail.component.html',
    };
  }

  FeatureCategoryDetailCtrl.$inject = ['UtilService', 'FeatureCategoryService'];

  function FeatureCategoryDetailCtrl(UtilService, FeatureCategoryService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = ['name', 'description'];

    // Methods
    vm.editFeatureCategory = editFeatureCategory;
    vm.openTranslations = openTranslations;
    vm.saveFeatureCategory = saveFeatureCategory;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.viewMode = true;

      if (mode === 'edit') {
        editFeatureCategory();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editFeatureCategory() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function openTranslations() {
      FeatureCategoryService.openFeatureCategoryTranslations(vm.item, vm.additionalLanguages);
    }

    // Create/Update
    function saveFeatureCategory(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        FeatureCategoryService.saveFeatureCategory(vm.item).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            if (!vm.editMode) {
              // create
              vm.item = response; // reload item
            }

            setItemOptions(response, vm.mode);

            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = false;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
